import React, { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components'
import PDFWorker from "worker-loader!pdfjs-dist/lib/pdf.worker";
import api from '../../services/api';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthContext'

import {
  PdfLoader,
  PdfHighlighter,
  Highlight,
  Popup,
  AreaHighlight,
  setPdfWorker
} from "react-pdf-highlighter";

import "./style/app.css";
import Spinner from "./spinner";
import Sidebar from "./sidebar";
import Tip from "./tip"

const Principal = styled.div`
display: flex;
height: 100%;
overflow: hidden; 
`;

const PDFContainer = styled.div`
  height: 100%;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
    display: ${props => props.status === true ? "none" : "block"}
  }
  @media (min-width: 768px) {
  width: ${props => props.status === true ? "75vw" : "100%"}
  }
`;

const RemoveMarker = styled.div`
    background-color: #F8642C;
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
`;

const OpenCloseButton = styled.div`
  position: absolute;
  z-index: 10;
  background-color: #408140;
  color: #fff;
  width: 150px;
  height: 35px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  padding: 5px 10px;
  text-align: center;
  top: 75px;
  left: 5px;
`


setPdfWorker(PDFWorker);

const getNextId = () => String(Math.random()).slice(2);

const parseIdFromHash = () =>
  document.location.hash.slice("#highlight-".length);

const resetHash = () => {
  document.location.hash = "";
};

const HighlightPopup = ({ comment, id, removeHighlight }) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
      <RemoveMarker onClick={() => removeHighlight(id)}>Remover grifo</RemoveMarker>
    </div>
  ) : null;

const PRIMARY_PDF_URL = ``;
const searchParams = new URLSearchParams(document.location.search);
const initialUrl = searchParams.get("url") || PRIMARY_PDF_URL;

function Highlighter(props) {
  const [url, setUrl] = useState(initialUrl)
  const [highlights, setHighlights] = useState([])
  const [isNew, setIsNew] = useState(true)
  const [userContentId, setUserContentId] = useState('')
  const { auth, dispatch } = useContext(AuthContext)
  const [sidebarStatus, setSidebarStatus] = useState(false)
  const pdfRef = useRef(null)


  const scrollToHighlightFromHash = () => {
    const highlight = getHighlightById(parseIdFromHash());
    if (highlight) {
      pdfRef.current.scrollTo(highlight)
    }
  };

  const getHighlightById = (id) => {
    return highlights.find(highlight => highlight.id === id);
  }

  useEffect(() => {
    api.get(`/userEmphasize/${props.match.params.id}`).then(res => {
      if (res.userEmphasize) {
        setIsNew(false)
        setUserContentId(res.userEmphasize._id);
        setUrl(`${process.env.REACT_APP_HOST}/static/${res.userEmphasize.content.fileName}`)
        setHighlights(res.userEmphasize.highlight)
      } else {
        api.get(`/content/${props.match.params.id}`).then(resContent => {
          setIsNew(true)
          setUrl(`${process.env.REACT_APP_HOST}/static/${resContent.content.fileName}`)
          setHighlights([])
        })
      }
    })
  }, [])

  useEffect(() => {
    window.addEventListener(
      "hashchange",
      scrollToHighlightFromHash
    );

    return () => {
      window.removeEventListener('hashchange', scrollToHighlightFromHash);
    }
  }, [scrollToHighlightFromHash])


  const saveHighlights = () => {
    if (isNew) {
      api.post('/userEmphasize', { content: props.match.params.id, student: auth.user._id, highlight: highlights }).then(res => {
        if (res.userEmphasize) {
          toast.success("Texto marcado com sucesso!")
        }
      }).catch(err => {
        console.log(err)
        toast.error("Ops, algo deu errado!")
      })
    } else {
      api.put(`/userEmphasize/${userContentId}`, { highlight: highlights }).then(res => {
        if (res.userEmphasize) {
          toast.success("Texto marcado com sucesso!")
        }
      }).catch(err => {
        toast.error("Ops, algo deu errado!")
      })
    }
  }

  const resetHighlights = () => {
    setHighlights([])
  };


  const goBack = () => {
    props.history.push(`/course/${props.match.params.courseId}/class/${props.match.params.classId}`)
  }

  const addHighlight = (highlight) => {
    console.log("Saving highlight", highlight);
    let newHighlights = highlights
    newHighlights.push({ ...highlight, id: getNextId() })
    setHighlights([...newHighlights])
  }

  const removeHighlight = (id) => {
    console.log("removing highlight", id);
    let newHighlights = highlights.filter(h => h.id !== id)
    setHighlights([...newHighlights])
  }

  const updateHighlight = (highlightId, position, content) => {
    console.log("Updating highlight", highlightId, position, content);
    let newHighlights = highlights.map(h => {
      const {
        id,
        position: originalPosition,
        content: originalContent,
        ...rest
      } = h;
      return id === highlightId
        ? {
          id,
          position: { ...originalPosition, ...position },
          content: { ...originalContent, ...content },
          ...rest
        }
        : h;
    })
    setHighlights([...newHighlights])
  }
  return <Principal>
    <OpenCloseButton onClick={() => setSidebarStatus(!sidebarStatus)}>
      {!sidebarStatus ? "Mostrar Grifos" : "Esconder Grifos"}
    </OpenCloseButton>
    <Sidebar
      highlights={highlights}
      saveHighlights={saveHighlights}
      resetHighlights={resetHighlights}
      removeHighlight={removeHighlight}
      goBack={goBack}
      sidebarStatus={sidebarStatus}
    />
    <PDFContainer status={sidebarStatus}>
      <PdfLoader url={url} beforeLoad={<Spinner />}>
        {pdfDocument => (
          <PdfHighlighter
            ref={pdfRef}
            pdfDocument={pdfDocument}
            enableAreaSelection={event => event.altKey}
            onScrollChange={resetHash}
            // pdfScaleValue="page-width"
            onSelectionFinished={(
              position,
              content,
              hideTipAndSelection,
              transformSelection
            ) => (
                <Tip
                  onOpen={transformSelection}
                  onConfirm={comment => {
                    addHighlight({ content, position, comment });
                    hideTipAndSelection();
                  }}
                />
              )}
            highlightTransform={(
              highlight,
              index,
              setTip,
              hideTip,
              viewportToScaled,
              screenshot,
              isScrolledTo
            ) => {
              const isTextHighlight = !Boolean(
                highlight.content && highlight.content.image
              );

              const component = isTextHighlight ? (
                <Highlight
                  isScrolledTo={isScrolledTo}
                  position={highlight.position}
                  comment={highlight.comment}
                />
              ) : (
                  <AreaHighlight
                    highlight={highlight}
                    onChange={boundingRect => {
                      updateHighlight(
                        highlight.id,
                        { boundingRect: viewportToScaled(boundingRect) },
                        { image: screenshot(boundingRect) }
                      );
                    }}
                  />
                );

              return (
                <Popup
                  popupContent={<HighlightPopup {...highlight} removeHighlight={removeHighlight} />}
                  onMouseOver={popupContent =>
                    setTip(highlight, highlight => popupContent)
                  }
                  onMouseOut={hideTip}
                  key={index}
                  children={component}
                />
              );
            }}
            highlights={highlights}
          />
        )}
      </PdfLoader>
    </PDFContainer>
  </Principal>;
}

export default Highlighter;